<template>
  <header class="admin-header">
    <div
      class="container d-flex justify-content-between align-items-center py-0"
    >
      <div>
        <router-link
          to="/businesses"
          class="d-flex align-items-center text-decoration-none"
        >
          <img
            src="@/core/assets/images/layout/logo-admin.png"
            alt="Logo panel de administración"
            class="sidebar-logo"
          />
          <!-- TODO replace app icon -->
          <h2 class="title text-white font-weight-bold text-uppercase my-0 mx-0">
            ZET
          </h2>
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AdminHeader",
  computed: {
    ...mapGetters({
      user: "auth/getUser",
      business: "app/getBusiness",
      businesses: "app/getBusinesses",
    }),
  },
  methods: {
    logout() {
      this.$store
        .dispatch("auth/logout");
      },
  },
};
</script>

<style lang="stylus" scoped>
@import "../Styles/header";
</style>
